import { openCartDrawerGlobal } from "./cartDrawer";

declare global {
  interface Window {
    openCartDrawerGlobal: typeof openCartDrawerGlobal;
  }
}

window.openCartDrawerGlobal = openCartDrawerGlobal;

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".cart-icon, #cartIconNav").forEach((cartIcon) => {
    cartIcon.addEventListener("click", (event) => {
      event.preventDefault();
      openCartDrawerGlobal(event);
    });
  });
});
